export const urls = {
  classifyApptKind: () => "/api/scheduler/classify-appt-kind/",
};

export const keys = {
  all: () => ["turbo"],

  classifyApptKinds: () => [...keys.all(), "appt-kind-classiffy"],
  classifyApptKind: (reason: string) => [...keys.classifyApptKinds(), reason],
};
